import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { initPushNotifications, teardownPushNotifications } from '../native/push';
import { isNativePlatform } from '../native/platform';

/**
 * Registers the device for push notifications once a user is authenticated
 * (native only). Safe to mount unconditionally: it no-ops on the web build.
 */
export const usePushNotifications = () => {
  const { user } = useAuth();

  useEffect(() => {
    // Push on Android requires Firebase (google-services.json). Calling
    // register() without it throws a fatal native exception that crashes the
    // app, so push is opt-in via REACT_APP_ENABLE_PUSH until FCM is configured.
    if (process.env.REACT_APP_ENABLE_PUSH !== 'true') return;
    if (!isNativePlatform() || !user?.id) return;

    initPushNotifications(
      user.id,
      (notification) => {
        console.log('Push received (foreground):', notification);
      },
      (action) => {
        // Deep-link based on payload, e.g. { route: '/my-tickets' }
        const route = action?.notification?.data?.route;
        if (route) {
          window.location.assign(route);
        }
      }
    );

    return () => {
      teardownPushNotifications();
    };
  }, [user?.id]);
};

export default usePushNotifications;
